import { render, staticRenderFns } from "./index.vue?vue&type=template&id=61be2112&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=61be2112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be2112",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/addStore/index.vue
// module id = null
// module chunks = 